module.exports = __webpack_public_path__ + "static/img/bg-tr.43bfa8f9.png";